import Popup from "../../../../common/components/popup";
import ModalPackageItemComponent from "./modal-package-details";
import Table from "../../../../common/components/table";
import { useRef, useState } from "react";
import { deepCopy } from "../../../../common/services/common.service";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { YesNoRendererComponent } from "../../../../common/components/yes-no-renderer.component";

export default function PackageDetails({ handleDelete, handleSavePackageItem, closeModal, handleEdit, handleAddItem, PackageType, handleInnerFormChange, columnDefs, variantLists, ProductLists, categoryListItems, packageItem, selectedPackageItem, addPackageItem, handleSteps }: any) {

  const NewPackageItemPopup = ({ handleSavePackageItem }: any) => {
    const [localPackItems, setLocalPackItems] = useState(deepCopy(selectedPackageItem));
    const handleLocalFormChange = (value: any, field: any) => {
      setLocalPackItems((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    };
    const handleFormSubmit = () => {
      setLocalPackItems(localPackItems);
      handleSavePackageItem(localPackItems)
    };
    return (
      <>
        <Popup onClose={closeModal}>
          <ModalPackageItemComponent
            Close={closeModal}
            selectedPackageItem={localPackItems}
            PackageType={PackageType}
            handlePackageItemSubmit={handleFormSubmit}
            ProductLists={ProductLists}
            categoryListItems={categoryListItems}
            variantLists={variantLists}
            handleInnerFormChange={handleLocalFormChange}

          />

        </Popup>
      </>
    )
  }

  const additionButtons: any = [
    {
      name: 'Add New Item',
      callback: () => handleAddItem(),
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleRightScroll = () => {
    if (currentIndex < packageItem.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleLeftScroll = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  };

  return (
    <>
      <div className="flex flex-row justify-center items-center  h-screen">
        <div className="h-[575px] bg-white shadow-xl m-3 w-[400px]">
          <div className="flex flex-col justify-center items-start p-6 space-y-5">

            {/* Arrow controls */}
            <div className='border-b-2 w-full border-slate-900 text-xl font-semibold p-2 flex items-center justify-between'>
              <div className="cursor-pointer  hover:text-hilight opacity-20 hover:opacity-90">
                <IoIosArrowBack size={20} onClick={handleLeftScroll} />
              </div>

              <div className="flex-1 text-center">Select Items</div>

              <div className="cursor-pointer  hover:text-hilight opacity-20 hover:opacity-90">
                <IoIosArrowForward size={20} onClick={handleRightScroll} />
              </div>
            </div>

            {/* Show one item based on the current index */}
            <div className="w-full flex justify-center items-center overflow-hidden">
              {packageItem?.slice(currentIndex, currentIndex + 1)?.map((packageItemData: any, index: any) => (
                <div key={index} className="border-b-2 w-[400px] border-slate-900 p-2">
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">S.no</label>
                    <label className="text-base">{currentIndex + 1}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg pr-5 font-semibold">Product Category</label>
                    <label className="text-base">{packageItemData.categoryName}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Product</label>
                    <label className="text-base">{packageItemData.productName}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Package Weight</label>
                    <label className="text-base">{packageItemData.weight} Kg</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Package Value</label>
                    <label className="text-base">₹ {packageItemData.value}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Package Type</label>
                    <label className="text-base">{packageItemData.packageType}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Number of Items</label>
                    <label className="text-base">{packageItemData.quantity}</label>
                  </div>
                  <div className="pb-6 flex justify-between items-center">
                    <label className="text-lg font-semibold">Dangerous Item</label>
                    <label className="text-base"><YesNoRendererComponent value={packageItemData.dangerous_goods} /></label>
                  </div>
                </div>
              ))}
            </div>
            <div className=" text-center">Total Package Items: {packageItem.length}</div>
          </div>
        </div>
        <div className="h-[575px] overflow-auto bg-white shadow-xl m-3 min-w-[900px]">
          <div className="flex flex-col justify-center items-start  p-5 space-y-5">
            <div className="w-full">
              <Table columnData={columnDefs} rowData={packageItem}
                onEdit={handleEdit} headingName="Package Details"
                additionButtons={additionButtons} onDelete={handleDelete} />
            </div>

            <div className='w-full flex justify-end px-10 space-x-3'>

              <button
                onClick={handleSteps}
                className='px-4 py-2 bg-primary text-light '>Next</button>
            </div>
          </div>
        </div>
      </div >
      {
        addPackageItem ? <NewPackageItemPopup handleSavePackageItem={handleSavePackageItem} /> : <></>
      }
    </>
  );
}
